import * as React from 'react'

export const AppConfig = () => {
  return <div>In App tab: App config to setup fields and features</div>
}
